import moment from 'jalali-moment';
import {useRef, useState, useEffect} from 'react';

interface ITimeState {
  isPast: boolean;
  months: number;
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}
interface CountDownCounterProps {
  dateTime: string;
}
const useCountDownCounter = ({dateTime}: CountDownCounterProps) => {
  const timerrRef = useRef<NodeJS.Timer | null>(null);
  const futureDate = moment(dateTime);

  const [timeState, setTimeState] = useState<ITimeState>({
    isPast: false,
    months: 0,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const getTimeRemaining = (): ITimeState => {
    const timeNow = moment();
    const chatgeTime = moment.duration(futureDate.diff(timeNow));
    const isPast = futureDate.isAfter(moment());
    const months = Math.floor(chatgeTime.asMonths());
    const days = chatgeTime.days();

    const seconds = chatgeTime.seconds();

    const minutes = chatgeTime.minutes();
    const hours = chatgeTime.hours();

    return {
      isPast,
      months,
      days,
      hours,
      minutes,
      seconds,
    };
  };
  const startTimer = () => {
    const timeremaining = getTimeRemaining();
    if (timeremaining.isPast) {
      setTimeState(timeremaining);
    }
  };
  const clearTimer = () => {
    setTimeState({
      isPast: false,
      months: 0,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    });

    if (timerrRef.current) clearInterval(timerrRef.current);
    const id = setInterval(() => {
      startTimer();
    }, 1000);
    timerrRef.current = id;
  };

  useEffect(() => {
    clearTimer();
  }, []);

  return timeState;
};

export default useCountDownCounter;
